import axios from "axios";
import { Key, useContext, useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import theme from "../styles/theme";
import Button from "./Button";
import FlexBox, { FlexGrow } from "./FlexBox";
import { StyledText } from "./Text";
import {
  Icon as MuiIcon,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import Icon, { ClickableIcon } from "./Icon";
import TableComponent, {
  StyledBodyCell,
  StyledHeaderCell,
  StyledTableRow,
} from "./Table";
import SkillDetailModal from "./SkillDetailModal";
import ModifySkillModal from "./ModifySkillModal";
import ConfirmTopicModal from "./ConfirmTopicModal";
import { CompetencyType } from "../types/Competency";
import ConfirmModal from "./ConfirmModal";
import DragNDrop from "./DragNDrop";
import SnackBar from "./SnackBar";
import { SaveButton } from "./PillarOverviewModify";
import { useNavigate } from "react-router-dom";
import Input, { InputTextArea } from "./Input";
import { EditTopic } from "./editTopic";
import { VersionContext } from "../context/VersionContext";
import { LegacyConfirmModal } from "../pages/Competencies/LegacyConfirmModal";

type CourseSkillsModifyType = {
  competencyData: CompetencyType;
  showBackButton?: boolean;
  code: string;
  goBack: () => void;
  onSaveComplete: () => void;
};
interface UnlinkedSkillColumn {
  id: "title" | "action";
  label: string;
  minWidth?: number;
  align?: "inherit" | "center" | "justify" | "left" | "right" | undefined;
  format?: (value: number) => string;
}
interface LinkedSkillColumn {
  id: "assessed_skill_code" | "title" | "action";
  label: string;
  minWidth?: number | string;
  maxWidth?: number | string;
  align?: "inherit" | "center" | "justify" | "left" | "right" | undefined;
  format?: (value: number) => string;
}
const linkedSkillColumns: readonly LinkedSkillColumn[] = [
  { id: "title", label: "Title", minWidth: "40%" },
  { id: "assessed_skill_code", label: "Skill Code", minWidth: "40%" },
  {
    id: "action",
    label: "",
    minWidth: "15%",
    align: "center",
  },
];

type SkillsInputs = {
  example: string;
  exampleRequired: string;
};

function CourseSkillsModify({
  competencyData,
  goBack,
  showBackButton = false,
  code,
}: CourseSkillsModifyType) {
  const { handleSubmit: handleSubmitSkills } = useForm<SkillsInputs>();
  const [linkedSkills, setLinkedSkills] = useState<Array<any>>(
    competencyData.skills || []
  );
  const [knowledgeTopics, setKnowledgeTopics] = useState<Array<any>>([]);
  const [addedTopics, setAddedTopics] = useState<Array<any>>([]);
  const [remainingTopics, setRemainingTopics] = useState<Array<any>>([]);

  const [currentSkill, setCurrentSkill] = useState<any>();
  const [currentTopic, setCurrentTopic] = useState();
  const [isDetailOpen, setIsDetailOpen] = useState<boolean>(false);
  const [isModifyOpen, setIsModifyOpen] = useState<boolean>(false);
  const [isCreateOpen, setIsCreateOpen] = useState<boolean>(false);
  const [isReorderOpen, setIsReorderOpen] = useState<boolean>(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState<boolean>(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [confirmMessage, setConfirmMessage] = useState<string>("");
  const [items, setItems] = useState<any>(linkedSkills);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [editTopicData, setEditTopicData] = useState<{
    id: string;
    title: string;
    description: string;
  }>({
    id: "",
    title: "",
    description: "",
  });
  const [legacyConfirmOpen, setLegacyConfirmOpen] = useState(false);
  const [legacyVersionsData, setLegacyVersionsData] = useState<any[]>([]);


  const navigate = useNavigate();
  const versionContext = useContext(VersionContext);
  const linkSkill = (skill: any) => {
    setCurrentTopic(skill);
    setIsCreateOpen(true);
  };
  const unlinkedSkillColumns: readonly UnlinkedSkillColumn[] = [
    {
      id: "title",
      label: "Topics in knowledge area " + competencyData.knowledge_area_title,
      minWidth: 80,
    },
    {
      id: "action",
      label: "",
      minWidth: 50,
      align: "right",
    },
  ];
  const onSubmitSkills: SubmitHandler<SkillsInputs> = () =>
    console.log("skills", linkedSkills);
  useEffect(() => {
    mapKnowledgeTopics();
    getAssessedSkill();
  }, [code]);
  const mapKnowledgeTopics = () => {
    let collectedTopics: Array<any> = [];
    axios
      .get(`/subdomain/summary?pillar_id=${competencyData?.pillar_id}&curriculum_version=${competencyData?.curriculum_version}`)
      .then((res) => {
        if (res.data.subdomains && res.data.subdomains.length > 0) {
          res.data.subdomains.forEach(
            (subdomain: { title: any; knowledge_areas: any[] }) => {
              if (subdomain.title === competencyData.subdomain_title) {
                subdomain.knowledge_areas.forEach(
                  (area: { title: string; knowledge_topics: any[] }) => {
                    if (area.title === competencyData.knowledge_area_title) {
                      area.knowledge_topics.forEach((topic) => {
                        collectedTopics.push(topic);
                      });
                    }
                  }
                );
              }
            }
          );

          axios
            .get(`/assessedskill?competency_template_id=${competencyData.id}&curriculum_version=${competencyData?.curriculum_version}`)
            .then((res1) => {
              const skillTopicIds = new Set(
                res1?.data?.assessedskills?.map(
                  (skill: any) => skill.skill.topic_id
                )
              );

              // Filter the topicArray to get addedTopic and remainingTopic
              const addedTopic = collectedTopics?.filter((topic) =>
                skillTopicIds?.has(topic?.id)
              );
              const remainingTopic = collectedTopics?.filter(
                (topic) => !skillTopicIds?.has(topic?.id)
              );
              setAddedTopics(addedTopic);
              setRemainingTopics(remainingTopic);
            })
            .catch((err) => {
              setLinkedSkills([]);
              setAddedTopics([]);
              setRemainingTopics(collectedTopics);
            });

          setKnowledgeTopics(
            collectedTopics?.sort((a, b) => a?.title?.localeCompare(b?.title))
          );
        } else {
          setKnowledgeTopics([]);
          setAddedTopics([]);
          setRemainingTopics(collectedTopics);
        }
      })
      .catch(() => {
        setKnowledgeTopics([]);
        setAddedTopics([]);
        setRemainingTopics(collectedTopics);
      });
  };

  const getAssessedSkill = () => {
    axios
      .get(`/assessedskill?competency_template_id=${competencyData.id}&curriculum_version=${competencyData?.curriculum_version}`)
      .then((res) => {
        setLinkedSkills(res.data.assessedskills);
        setItems(res.data.assessedskills);
      })
      .catch((err) => {
        setLinkedSkills([]);
      });
  };
  const addSkill = (fdata: any, topicData: any) => {
    const engSLO = fdata.engineering_slo?.map((e: any) => e.value) || [];
    const comSLO = fdata.computing_slo?.map((e: any) => e.value) || [];
    const paramData = {
      skill_title: fdata.skill_title,
      skill_description: fdata.skill_description,
      assessment_description: fdata.assessment_description,
      // assessment_title: fdata.assessment_title,
      assessment_type_id: fdata.assessment_type,
      cognitive_skill: fdata.complexity_level,
      competency_template_id: competencyData.id,
      topic_id: topicData.id,
      engineering_slo: engSLO,
      computing_slo: comSLO,
    };
    axios
      .post(`/assessedskill/new`, paramData)
      .then((res) => {
        getAssessedSkill();
        setIsCreateOpen(false);
        setIsSnackbarOpen(true);
        setMessage(res.data.message || "New assessed skill added successfully!");
        mapKnowledgeTopics();

        // competencyData?.version_status === "Active Prime" && checkLegacyVersions(competencyData?.competency_code, competencyData?.curriculum_version);
      })
      .catch((err) => {
        setErrorMessage(
          err.response.data.error || "Failed to add new assessed skill!"
        );
        setIsErrorOpen(true);
      });
  };
  const { version } = useContext(VersionContext);

  const updateSkill = (fdata: any, topicData: any) => {
    const paramData = {
      skill_description: fdata.skill_description,
      skill_title: fdata.skill_title,
      assessment_description: fdata.assessment_description,
      assessment_title: fdata.assessment_title,
      assessment_type_id: fdata.assessment_type_id,
      assessed_skill_id: topicData.id,
      engineering_slo: fdata.engineering_slo.map((e: any) => e.value || e.id),
      computing_slo: fdata.computing_slo.map((e: any) => e.value || e.id),
      cognitive_skill: fdata.complexity_level,
      competency_template_id: competencyData.id,
      curriculum_version: version.version_number,
    };
    axios
      .put(`/assessedskill/update`, paramData)
      .then((res) => {
        setIsModifyOpen(false);
        getAssessedSkill();
        setIsSnackbarOpen(true);
        setMessage(res.data.message || "Assessed skill updated successfully!");

        // competencyData?.version_status === "Active Prime" && checkLegacyVersions(competencyData?.competency_code, competencyData?.curriculum_version);
      })
      .catch((err) => {
        setErrorMessage(
          err.response.data.error || "Failed to update assessed skill!"
        );
        setIsErrorOpen(true);
      });
  };

  const saveClone = (
    competency_code: string,
    source_version: number,
    target_versions: number[]
  ) => {
    axios.put("/competency/auto-propagate", {
      competency_code,
      source_version,
      target_versions
    }).then(() => {
      setLegacyConfirmOpen(false);
      setIsSnackbarOpen(true);
      setMessage("Competency cloned to legacy version(s) successfully");
    }).catch((err) => {
      setIsErrorOpen(true);
      console.log(err?.response);
      setErrorMessage(
        err?.response?.data?.error || "Failed to clone competency"
      );
    });
  };

  const checkLegacyVersions = (competency_code: string, version: number | undefined) => {
    // e.preventDefault();
    // e.stopPropagation();
    // updateSkill(fdata, topicData);
    if (!competency_code || !version) {
      return;
    }
    axios.get(`/competency/legacy-versions?competency_code=${competency_code}&curriculum_version=${version}`)
      .then((data: any) => {
        const legacyVersions = data?.data?.["legacy-versions"] ?? [];
        if (legacyVersions.length > 0) {
          setLegacyVersionsData(legacyVersions);
          setLegacyConfirmOpen(true);
        } else {
        }
      })
      .catch(() => {
      });
  };

  const confirmDelete = (skill: any) => {
    setIsDeleteOpen(true);
    setCurrentSkill(skill);
    // setLinkedSkills(linkedSkills.filter((current) => current.id !== skill.id));
  };
  const deleteSkill = () => {
    axios
      .delete(
        `/assessedskill/remove?competency_template_id=${competencyData.id}&assessed_skill_id=${currentSkill.id}&curriculum_version=${versionContext?.version?.version_number}`
      )
      .then((res) => {
        setIsDeleteOpen(false);
        setIsSnackbarOpen(true);
        setMessage(res.data.message || "Assessed skill deleted successfully!");
        getAssessedSkill();
        mapKnowledgeTopics();
        // competencyData?.version_status === "Active Prime" && checkLegacyVersions(competencyData?.competency_code, competencyData?.curriculum_version);

      })
      .catch((err) => {
        setErrorMessage(
          err?.response?.data?.error || "Failed to delete assessed skill!"
        );
        setIsErrorOpen(true);
      });
  };
  const saveOrder = () => {
    const assessSkillArray: any = [];
    const data = {
      competency_template_id: competencyData.id,
      assessed_skills: [
        items.forEach((item: any) =>
          assessSkillArray.push({ assessed_skill_id: item.id })
        ),
      ],
    };
    axios
      .put(`/assessedskill/reorder`, {
        competency_template_id: competencyData.id,
        assessed_skills: assessSkillArray,
        curriculum_version: versionContext?.version?.version_number,
      })
      .then((res) => {
        getAssessedSkill();
        setIsReorderOpen(false);
        setIsSnackbarOpen(true);
        setMessage(res.data.message || "Assessed skill reordered successfully!");
      })
      .catch((err) => {
        setErrorMessage(
          err.response.data.error || "Failed to reorder assessed skill!"
        );
        setIsErrorOpen(true);
      });
  };
  const handleEditTopic = () => {
    if (editTopicData.id === "new") {
      axios
        .post(`/knowledgetopic/new`, {
          ...editTopicData,
          area_id: competencyData.knowledge_area_id,
        })
        .then((res) => {
          setIsSnackbarOpen(true);
          setMessage(res.data.message || "Knowledge topic created successfully!");
          mapKnowledgeTopics();
          getAssessedSkill();
          setEditTopicData({ id: "", title: "", description: "" });
        })
        .catch((err: any) => {
          setErrorMessage(
            err.response.data.error || "Failed to create knowledge topic!"
          );
          setIsErrorOpen(true);
        });
    } else {
      axios
        .put(`/knowledgetopic/update`, editTopicData)
        .then((res) => {
          setIsSnackbarOpen(true);
          setMessage(res.data.message || "Knowledge topic updated successfully!");
          mapKnowledgeTopics();
          getAssessedSkill();
          setEditTopicData({ id: "", title: "", description: "" });
        })
        .catch((err: any) => {
          setErrorMessage(
            err.response.data.error || "Failed to update knowledge topic!"
          );
          setIsErrorOpen(true);
        });
    }
  };

  const handleDelete = () => {
    setIsDeleteOpen(true);
  };
  const deleteTopic = () => {
    axios
      .delete(
        `/knowledgetopic/delete?topic_id=${editTopicData.id
        }&curriculum_version=${versionContext?.version}&override_usage=${confirmMessage ? true : false
        }`
      )
      .then((res: any) => {
        if (!res.data.result.deleted) {
          setConfirmMessage(res.data.result.message);
        } else {
          mapKnowledgeTopics();
          getAssessedSkill();
          setConfirmMessage("");
          setIsDeleteOpen(false);
          setMessage(res.data.message || "Deleted Knowledge Topic successfully!");
          setIsSnackbarOpen(true);
          setEditTopicData({ id: "", title: "", description: "" });
        }
      })
      .catch((err: any) => {
        setErrorMessage(
          err.response.data.error || "Failed to delete knowledge topic!"
        );
        setIsErrorOpen(true);
      });
  };

  return (
    <>
      {legacyConfirmOpen && (
        <LegacyConfirmModal
          saveClone={saveClone}
          competencyData={{
            competency_code: competencyData.competency_code,
            curriculum_version: competencyData.curriculum_version ?? 0,
          }}
          legacyVersionsData={legacyVersionsData}
          isOpen={legacyConfirmOpen}
          setOpen={setLegacyConfirmOpen}
        />
      )}
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={errorMessage}
        type="error"
      />
      <ConfirmModal
        isOpen={isDeleteOpen}
        setOpen={setIsDeleteOpen}
        confirmFunction={editMode ? deleteTopic : deleteSkill}
        title={editMode ? "Remove Knowledge Topic" : "Remove Assess Skill"}
        description={
          editMode
            ? confirmMessage
              ? confirmMessage
              : "Are you sure you want to remove this knowledge topic?"
            : competencyData?.has_cards ?
              `⚠️ When this version was adopted, competency [${competencyData?.competency_code}] had [${competencyData?.original_skill_count}] assessed skills. \n You can add or delete skills as long as you do not change the scope of the competency by more than 50%
              \n⚠️ There are students currently registered for this competency. Changes to skills may affect assessments and student progress. Please ensure your Canvas course reflects and aligns with the updated skills\n\n Are you sure you want to remove this assessed skill?` :
              `⚠️ When this version was adopted, competency [${competencyData?.competency_code}] had [${competencyData?.original_skill_count}] assessed skills. \n You can add or delete skills as long as you do not change the scope of the competency by more than 50% \n\n Are you sure you want to remove this assessed skill?`

        }
      />
      {currentSkill && isDetailOpen && (
        <SkillDetailModal
          isOpen={isDetailOpen}
          setOpen={setIsDetailOpen}
          data={currentSkill}
        />
      )}
      {currentSkill && isModifyOpen && (
        <ModifySkillModal
          onSubmit={updateSkill}
          // onSubmit={(fdata: any, data: any) => console.log(fdata, data)}

          header={competencyData?.derived_from_id ? "Skill Detail" : "Modify Skill"}
          mode="modify"
          isOpen={isModifyOpen}
          setOpen={setIsModifyOpen}
          data={currentSkill}
        />
      )}
      {isCreateOpen && (
        <ConfirmTopicModal
          competencyData={competencyData}
          isOpen={isCreateOpen}
          setOpen={setIsCreateOpen}
          data={currentTopic}
          onSubmit={(formData, topicData) => {
            addSkill(formData, topicData);
          }}
        />
      )}
      {/* {isReorderOpen && (
        <ReorderSkillModal
          isOpen={isReorderOpen}
          setOpen={setIsReorderOpen}
          data={currentTopic}
          onSubmit={(formData, topicData) => {
            addSkill(formData, topicData);
          }}
        />
      )} */}
      <form
        onSubmit={handleSubmitSkills(onSubmitSkills)}
        style={{
          height: "70vh",
          overflowY: "scroll",
          paddingLeft: 5,
        }}
      >
        <FlexBox
          alignItems="flex-start"
          style={{
            flexWrap: "nowrap",
            marginTop: "8px",
            // marginBottom: '50px',
          }}
        >
          <FlexGrow>
            <TableComponent
              style={{
                maxHeight: "60vh",
                minHeight: "60vh",
                borderRadius: "5px",
                // borderTopLeftRadius: "16px",
                // border: "1px solid #d0d0d0",
                boxShadow: "0 0 2px gray",
              }}
              navHeight="341px"
              aria-label="sticky table"
            >
              <TableHead sx={{ position: "sticky", top: 0 }}>
                <TableRow>
                  <StyledHeaderCell
                    align="left"
                    colSpan={4}
                    backgroundColor={theme.color.lightBlueGray200}
                    color={theme.color.lightBlueGray800}
                    style={{
                      fontWeight: "bold",
                      borderBottom: `1px solid ${theme.color.lightBlueGray400}`,
                      height: "40px",
                      padding: "8px 16px",
                      fontSize: "16px",
                    }}
                  >
                    <FlexBox justify="space-between">
                      <span>Knowledge Topics</span>
                      {!editMode && !competencyData?.derived_from_id && (
                        <SaveButton
                          className="reduce_opct_onhover"
                          style={{
                            // padding: "0 6px",
                            minWidth: "52px",
                            background: theme.color.editButton,
                            // backgroundColor: "#0061ff",
                            color: "white",
                            border: "none",
                          }}
                          type="button"
                          onClick={() => {
                            setEditMode(!editMode);
                          }}
                        >
                          <StyledText
                            style={{
                              fontSize: "12px",
                              display: "flex",
                              alignItems: "center",
                              gap: 5,
                            }}
                          >
                            <Icon fixedWidth={false} size={2} name="edit" />
                            Edit
                          </StyledText>
                        </SaveButton>
                      )}
                    </FlexBox>
                  </StyledHeaderCell>
                </TableRow>
                <TableRow>
                  {unlinkedSkillColumns.map((column) => (
                    <StyledHeaderCell
                      key={column.id}
                      align={column.align}
                      backgroundColor={theme.color.lightBlueGray200}
                      color={theme.color.lightBlueGray800}
                      style={{
                        minWidth: column.minWidth,
                        top: "35px",
                        height: "40px",
                      }}
                    >
                      {editMode &&
                        column.id === "action" &&
                        editTopicData.id !== "new" ? (
                        <SaveButton
                          className="reduce_opct_onhover"
                          style={{
                            color: "white",
                            background: theme.color.greenButton,
                          }}
                          type="button"
                          onClick={() => {
                            setEditTopicData({
                              id: "new",
                              description: "",
                              title: "",
                            });
                          }}
                        >
                          <StyledText
                            style={{
                              fontSize: "12px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Icon size={2} name="add_icon" />
                            Knowledge Topic
                          </StyledText>
                        </SaveButton>
                      ) : (
                        column.label
                      )}
                    </StyledHeaderCell>
                  ))}
                </TableRow>
              </TableHead>
              {addedTopics?.length > 0 && (
                <TableBody style={{ position: "sticky", top: 110 }}>
                  <TableRow>
                    <StyledBodyCell
                      align="left"
                      colSpan={4}
                      color={theme.color.lightBlueGray800}
                      style={{
                        fontWeight: "bold",
                        borderBottom: `1px solid ${theme.color.lightBlueGray200}`,
                        // height: "40px",
                        background: "#f9f9ff",
                        // padding: "8px 16px",
                      }}
                    >
                      <FlexBox
                        style={{
                          fontWeight: "bold",
                          gap: 2,
                          display: "flex",
                          alignItems: "center",
                          color: "blue",
                          background: "#f9f9ff",
                        }}
                      >
                        <Icon fixedWidth={false} size={2} name="link" />
                        <span style={{ fontSize: 12 }}>
                          Topics currently associated with this competency
                        </span>
                      </FlexBox>
                    </StyledBodyCell>
                  </TableRow>
                </TableBody>
              )}
              <TableBody>
                {addedTopics.map((row: any, index: Key | null | undefined) => {
                  return (
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      // onClick={() => {
                      //   setCurrentSkill(row);
                      //   setIsDetailOpen(true);
                      // }}
                      onClick={() => editMode && setEditTopicData(row)}
                      key={index}
                    >
                      {unlinkedSkillColumns.map((column) => {
                        const value = row[column.id];
                        if (column.id === "action" && !editMode && !competencyData?.derived_from_id) {
                          return (
                            <StyledBodyCell
                              key={column.id}
                              verticalAlignCustom="middle"
                              align={column.align}
                            >
                              <ClickableIcon
                                name={"add_box"}
                                color="black"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  linkSkill(row);
                                }}
                              />
                            </StyledBodyCell>
                          );
                        }
                        return (
                          <StyledBodyCell
                            key={column.id}
                            align={column.align}
                            style={{
                              color: editTopicData.id === row.id ? "blue" : "",
                            }}
                          // onDoubleClick={() =>
                          //   navigate(
                          //     `/modify/pillar/${competencyData?.pillar_id}/subdomain/${competencyData?.subdomain_id}/knowledge-area/${competencyData?.knowledge_area_id}/knowledge-topic`
                          //   )
                          // }
                          >
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </StyledBodyCell>
                        );
                      })}
                    </StyledTableRow>
                  );
                })}
                {remainingTopics?.length > 0 && (
                  <TableRow
                    style={{
                      fontWeight: "bold",
                      position: "sticky",
                      top: 110,
                      bottom: 0,
                      background: "#f9f9ff",
                    }}
                  >
                    <StyledBodyCell
                      align="left"
                      colSpan={4}
                      color={theme.color.lightBlueGray800}
                      style={{
                        fontWeight: "bold",
                        borderBottom: `1px solid ${theme.color.lightBlueGray200}`,
                        // height: "40px",
                        background: "#f9f9ff",
                        // padding: "8px 16px",
                      }}
                    >
                      <FlexBox
                        style={{
                          fontWeight: "bold",
                          gap: 2,
                          display: "flex",
                          alignItems: "center",
                          color: "blue",
                          background: "#f9f9ff",
                        }}
                      >
                        <Icon fixedWidth={false} size={2} name="link_off" />{" "}
                        <span style={{ fontSize: 12 }}>
                          Other topics in this knowledge area
                        </span>
                      </FlexBox>
                    </StyledBodyCell>
                    {/* <TableCell
                      style={{
                        fontWeight: "bold",
                        gap: 2,
                        display: "flex",
                        alignItems: "center",
                        color: "blue",
                        fontSize: 12,
                      }}
                    >
                      <Icon fixedWidth={false} size={2} name="link_off" />
                      Other topics in this knowledge area
                    </TableCell>
                    <TableCell></TableCell> */}
                  </TableRow>
                )}
                {remainingTopics.map(
                  (row: any, index: Key | null | undefined) => {
                    return (
                      <StyledTableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        // onClick={() => {
                        //   setCurrentSkill(row);
                        //   setIsDetailOpen(true);
                        // }}
                        onClick={() => editMode && setEditTopicData(row)}
                        key={index}
                      >
                        {unlinkedSkillColumns.map((column) => {
                          const value = row[column.id];
                          if (column.id === "action" && !editMode && !competencyData?.derived_from_id) {
                            return (
                              <StyledBodyCell
                                key={column.id}
                                verticalAlignCustom="middle"
                                align={column.align}
                              >
                                <ClickableIcon
                                  name={"add_box"}
                                  color="black"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    linkSkill(row);
                                  }}
                                />
                              </StyledBodyCell>
                            );
                          }
                          return (
                            <StyledBodyCell
                              key={column.id}
                              align={column.align}
                              style={{
                                color:
                                  editTopicData.id === row.id ? "blue" : "",
                              }}
                            // onDoubleClick={() =>
                            //   navigate(
                            //     `/modify/pillar/${competencyData?.pillar_id}/subdomain/${competencyData?.subdomain_id}/knowledge-area/${competencyData?.knowledge_area_id}/knowledge-topic`
                            //   )
                            // }
                            >
                              {column.format && typeof value === "number"
                                ? column.format(value)
                                : value}
                            </StyledBodyCell>
                          );
                        })}
                      </StyledTableRow>
                    );
                  }
                )}
              </TableBody>
            </TableComponent>
          </FlexGrow>
          <FlexGrow>
            {!editMode ? (
              <TableComponent
                style={{
                  borderRadius: "5px",
                  minHeight: "60vh",
                  maxHeight: "60vh",
                  // border: "1px solid #d0d0d0",
                  boxShadow: "0 0 2px gray",
                }}
                autoHeight={true}
                navHeight="0"
                aria-label="sticky table"
              >
                <TableHead>
                  <TableRow>
                    <StyledHeaderCell
                      colSpan={5}
                      backgroundColor={theme.color.lightBlueGray200}
                      color={theme.color.lightBlueGray800}
                      style={{
                        borderBottom: `1px solid ${theme.color.lightBlueGray400}`,
                        height: "40px",
                        padding: "8px",
                        zIndex: 1000,
                      }}
                    >
                      <FlexBox>
                        <FlexGrow
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            paddingLeft: 8,
                          }}
                        >
                          Assessed Skills
                        </FlexGrow>
                        {!competencyData?.derived_from_id && <FlexGrow style={{ textAlign: "end" }}>
                          {isReorderOpen ? (
                            <>
                              <Button
                                className="reduce_opct_onhover"
                                style={{
                                  width: "120px",
                                  border: "2px solid rgb(100, 116, 139)",
                                  marginRight: 10,
                                }}
                                isOutline
                                // type="button"
                                onClick={() => {
                                  setIsReorderOpen(false);
                                }}
                              >
                                <StyledText style={{ fontSize: "12px" }}>
                                  Cancel
                                </StyledText>
                              </Button>
                              <SaveButton
                                className="reduce_opct_onhover"
                                style={{
                                  color: "white",
                                }}
                                type="button"
                                onClick={() => {
                                  saveOrder();
                                }}
                              >
                                <StyledText style={{ fontSize: "12px" }}>
                                  Save
                                </StyledText>
                              </SaveButton>
                            </>
                          ) : (
                            <SaveButton
                              className="reduce_opct_onhover"
                              style={{
                                // padding: "0 6px",
                                minWidth: "52px",
                                // marginRight: "6px",
                                // backgroundColor: "#0061ff",
                                color: "white",
                                border: "none",
                              }}
                              type="button"
                              onClick={() => {
                                setIsReorderOpen(true);
                              }}
                            >
                              <FlexBox space={0} style={{ flexWrap: "nowrap" }}>
                                <Icon
                                  fixedWidth={false}
                                  size={2}
                                  name="unfold_more"
                                />
                                <FlexGrow style={{ width: "min-content" }}>
                                  <StyledText
                                    style={{ fontSize: "12px", marginLeft: 5 }}
                                  >
                                    Reorder
                                  </StyledText>
                                </FlexGrow>
                              </FlexBox>
                            </SaveButton>
                          )}
                        </FlexGrow>}
                        {/* <FlexGrow style={{ textAlign: "end" }}></FlexGrow> */}
                      </FlexBox>
                    </StyledHeaderCell>
                  </TableRow>
                  <TableRow>
                    {linkedSkillColumns.map((column) => (
                      <StyledHeaderCell
                        key={column.id}
                        align={column.align}
                        backgroundColor={theme.color.lightBlueGray200}
                        color={theme.color.lightBlueGray800}
                        style={{
                          minWidth: column.minWidth,
                          maxWidth: column.maxWidth,
                          height: "40px",
                        }}
                      >
                        {column.label}
                      </StyledHeaderCell>
                    ))}
                  </TableRow>
                </TableHead>
                {isReorderOpen ? (
                  <DragNDrop
                    data={linkedSkills}
                    items={items}
                    setItems={setItems}
                  />
                ) : (
                  <TableBody>
                    {linkedSkills?.map((row: any) => {
                      return (
                        <StyledTableRow
                          hover
                          role="checkbox"
                          // onClick={() => {
                          //   setCurrentSkill(row);
                          //   setIsDetailOpen(true);
                          // }}
                          onDoubleClick={() => {
                            setCurrentSkill(row);
                            setIsModifyOpen(true);
                          }}
                        >
                          {linkedSkillColumns.map(
                            (column: LinkedSkillColumn) => {
                              const value = row[column.id] || row?.skill?.title;

                              if (column.id === "action") {
                                return (
                                  <StyledBodyCell
                                    key={column.id}
                                    verticalAlignCustom="middle"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                    }}
                                    align={column.align}
                                  >
                                    {competencyData?.derived_from_id ?
                                      <ClickableIcon
                                        name={"visibility"}
                                        color="black"
                                        onClick={() => {
                                          setCurrentSkill(row);
                                          setIsModifyOpen(true);
                                        }}
                                      /> :
                                      <><ClickableIcon
                                        name={"edit"}
                                        color="black"
                                        onClick={() => {
                                          setCurrentSkill(row);
                                          setIsModifyOpen(true);
                                        }}
                                      />
                                        <ClickableIcon
                                          name={"delete"}
                                          color="red"
                                          onClick={() => {
                                            confirmDelete(row);
                                          }}
                                        /></>}
                                  </StyledBodyCell>
                                );
                              }
                              return (
                                <StyledBodyCell
                                  key={column.id}
                                  align={column.align}
                                >
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </StyledBodyCell>
                              );
                            }
                          )}
                        </StyledTableRow>
                      );
                    })}
                  </TableBody>
                )}
              </TableComponent>
            ) : (
              <div
                style={{
                  borderRadius: "5px",
                  minHeight: "60vh",
                  maxHeight: "60vh",
                  minWidth: 250,
                  // border: "1px solid #d0d0d0",
                  boxShadow: "0 0 2px gray",
                  background: "#eef5fd",
                  position: "relative",
                  marginRight: 10,
                }}
              >
                {editTopicData.id ? (
                  <EditTopic
                    handleDelete={handleDelete}
                    editTopicData={editTopicData}
                    setEditTopic={setEditTopicData}
                    handleEditTopic={handleEditTopic}
                  />
                ) : (
                  <div
                    style={{ color: "black", textAlign: "center", padding: 20 }}
                  >
                    <div
                      onClick={() => {
                        setEditMode(false);
                      }}
                      className="reduce_opct_onhover"
                      style={{
                        color: "rgb(38, 51, 212)",
                        alignItems: "center",
                        display: "flex",
                        gap: 10,
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      <Icon name={"arrow_back"}></Icon>Go Back
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: 200,
                        gap: 10,
                      }}
                    >
                      {" "}
                      <Icon
                        style={{
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "center",
                        }}
                        fixedWidth={false}
                        color="#009e06"
                        name={"info"}
                      />
                      Select a knowledge topic to edit
                    </div>
                  </div>
                )}
              </div>
            )}
          </FlexGrow>
        </FlexBox>
      </form>
    </>
  );
}
export default CourseSkillsModify;
